import React from 'react'
import { useSelector } from 'react-redux'

import { getLocation } from 'ducks/router'

const useSearchState = () => {
  const { query = {} } = useSelector(getLocation)

  const [search, setSearch] = React.useState(query?.search ?? '')

  return { search, setSearch }
}

export const useSearch = () => {
  const { search, setSearch } = useSearchState()

  return [search, setSearch]
}
